/**
 * @name quantity
 * @description Display formatting for unit counts shared across the app.
 *
 * Quantities are stored as `numeric` in Postgres because a handful of units
 * are genuinely divisible (metres of fabric, kilos of resin), but the vast
 * majority of lines are whole cartons and pieces. Formatting those with a
 * fixed two decimals reads as money rather than units, so `500.00` looks like
 * a price sitting in the quantity column.
 */

/**
 * @name formatQuantity
 * @description Format a unit count for display: whole numbers stay whole, and
 * only genuinely fractional quantities keep their decimals.
 *
 * `500` renders as `500`, `9060` as `9,060`, and `10.5` as `10.5`.
 */
export function formatQuantity(
  value: number | string | null | undefined,
  locale = 'en-US',
): string {
  const quantity = Number(value);

  if (!Number.isFinite(quantity)) {
    return '0';
  }

  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: 2,
  }).format(quantity);
}
